import { IsNotEmpty, IsOptional, IsIn, IsArray, IsString, IsNumber, Min, Max } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IRunningOrderDogClass } from "./running-order-dog-class.interface";

export class RunningOrderDogClassDto implements IRunningOrderDogClass {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.running_order_dog_class_type))
  type: string;

  @IsOptional()
  duration?: number; // minutes

  @IsOptional()
  time_limit?: string; // mm:ss:tt

  @IsOptional()
  num_hides?: number;

  @IsOptional()
  time_limit_search_1?: string; // mm:ss:tt (Master level - search 1)

  @IsOptional()
  num_hides_search_1?: number; // Master level - search 1

  @IsOptional()
  time_limit_search_2?: string; // mm:ss:tt (Master level - search 2)

  @IsOptional()
  num_hides_search_2?: number; // Master level - search 2

  @IsOptional()
  time_limit_search_3?: string; // mm:ss:tt (Master level - search 3, Interior only)

  @IsOptional()
  num_hides_search_3?: number; // Master level - search 3, Interior only

  @IsOptional()
  show_element?: string;

  @IsOptional()
  level?: string;

  @IsOptional()
  @IsString()
  time_slot?: string; // Used for Fast CAT to store the timeslot (Morning, Afternoon, etc.)

  @IsOptional()
  group_with?: string;

  @IsOptional()
  name?: string; // Custom name for breaks

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  dog_run_order?: string[]; // Array of score_ids in custom order

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  completed_dogs?: string[]; // Array of score_ids that have completed their runs

  @IsOptional()
  @IsNumber()
  @Min(1)
  @Max(4)
  split_number?: number;

  @IsOptional()
  @IsNumber()
  @Min(1)
  @Max(4)
  split_total?: number;

  @IsOptional()
  @IsNumber()
  day_order?: number;
}
